import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';

export default function Contact() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 via-white to-green-50">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-emerald-400 via-green-400 to-teal-400 rounded-full mb-6 shadow-lg">
            <i className="ri-mail-line text-white text-4xl"></i>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-green-800 mb-4">
            お問い合わせ
          </h1>
          <p className="text-gray-600 leading-relaxed">
            ご質問やご意見がございましたら、お気軽にお問い合わせください。<br />
            できる限り迅速に対応させていただきます。
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
          <div className="mb-8">
            <div className="flex items-start space-x-4 p-6 bg-green-50 rounded-lg border-l-4 border-green-400">
              <div className="flex-shrink-0">
                <i className="ri-information-line text-green-600 text-2xl"></i>
              </div>
              <div>
                <h3 className="font-semibold text-green-800 mb-2">お問い合わせについて</h3>
                <p className="text-gray-700 text-sm leading-relaxed">
                  以下のフォームからお問い合わせください。<br />
                  いただいた個人情報は返信のためのみに利用いたします。
                </p>
              </div>
            </div>
          </div>

          <div className="mb-8">
            <h2 className="text-xl font-bold text-green-800 mb-6 flex items-center">
              <span className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                <i className="ri-edit-line text-green-600"></i>
              </span>
              お問い合わせフォーム
            </h2>
            
            <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-lg p-8 border border-green-200">
              <div className="text-center mb-6">
                <p className="text-gray-700 mb-4">
                  下記のボタンをクリックして、お問い合わせフォームにご記入ください。
                </p>
              </div>
              
              <div className="flex justify-center">
                <a
                  href="https://forms.gle/NeAmic4N9XBvC8G88"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:from-green-600 hover:to-emerald-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-external-link-line text-xl mr-2"></i>
                  お問い合わせフォームを開く
                </a>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
            <div className="flex items-start space-x-4 p-6 bg-gray-50 rounded-lg">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-green-600 text-xl"></i>
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">返信について</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  通常、2〜3営業日以内にご返信いたします。
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4 p-6 bg-gray-50 rounded-lg">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-line text-green-600 text-xl"></i>
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-gray-800 mb-2">個人情報保護</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  お預かりした情報は適切に管理いたします。
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-gray-200 text-center">
            <p className="text-gray-600 text-sm">
              個人情報の取り扱いについては、
              <a href="/privacy-policy" className="text-green-600 hover:text-green-700 font-medium cursor-pointer">
                プライバシーポリシー
              </a>
              をご確認ください。
            </p>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-pink-400 to-rose-400 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-plant-line text-white text-2xl"></i>
            </div>
            <h3 className="font-semibold text-gray-800 mb-2">植物について</h3>
            <p className="text-gray-600 text-sm">
              植物の育て方や花言葉についてのご質問
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-400 to-teal-400 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-feedback-line text-white text-2xl"></i>
            </div>
            <h3 className="font-semibold text-gray-800 mb-2">ご意見・ご要望</h3>
            <p className="text-gray-600 text-sm">
              サイトへのご意見やご要望をお聞かせください
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-green-400 to-lime-400 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-question-line text-white text-2xl"></i>
            </div>
            <h3 className="font-semibold text-gray-800 mb-2">その他</h3>
            <p className="text-gray-600 text-sm">
              サイトに関するお問い合わせ全般
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
